import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
  TimeAccountSummaryQuery,
  TimeAccountSummaryTimeEntryPageModel
} from '@/services/api/nswag/stapiclient_generated';

import { stTimeAccountApi } from '@/services/st-api';

@Module({ dynamic: true, store, name: 'TimeAccountModule', namespaced: true })
export default class TimeAccountModule extends VuexModule {
  public TimeAccountSummary: TimeAccountSummaryTimeEntryPageModel = TimeAccountSummaryTimeEntryPageModel.fromJS({});
  public loading: boolean = false;
  public isLoaded: boolean = false;

  @Mutation
  setTimeAccountSummary(data: TimeAccountSummaryTimeEntryPageModel) {
    this.TimeAccountSummary = data;
    this.isLoaded = true;
  }

  @Mutation
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Action
  async LoadTimeAccountSummary(query: TimeAccountSummaryQuery) {
    this.setLoading(true);

    const result = await stTimeAccountApi.getTimeAccountSummaryForTimeEntriesPage(query);
    this.setTimeAccountSummary(result);

    this.setLoading(false);
  }
}

export const TimeAccountStore = getModule(TimeAccountModule);
